import React from 'react';
import PropTypes from 'prop-types';
import GenericCommissioningContent from 'src/screen/Protected/DeviceScreen/Commissioning/GenericCommissioningContent';
import CommissioningCommLoopReport from './CommissioningCommLoopReport';

export default function CommissioningCommLoopContent (props) {
  const { deviceId } = props;

  return (
    <GenericCommissioningContent
      deviceId={deviceId}
      checkSheetType="commissioning-comm-loop"
      titleKey="commissioningCommLoop.title"
      createReportButtonKey="commissioningCommLoop.createReport"
      tableId="device-commissioning-comm-loop-table"
      contentTestId="commissioning-comm-loop-content"
      fetchTaskType="commissioning-comm-loop-general"
      ReportComponent={CommissioningCommLoopReport}
    />
  );
}

CommissioningCommLoopContent.propTypes = {
  deviceId: PropTypes.string,
};

CommissioningCommLoopContent.defaultProps = {
  deviceId: null,
};
